/* src/app/components/on-off-tri-toggle/on-off-tri-toggle.component.scss */
.toggle-container {
  display: grid;
  grid-template-columns: 1fr 42px 1fr;
  min-width: 144px;
  height: 36px;
  border: 1px solid #02857D;
  cursor: pointer;
  color: #242424;
}
.toggle-container.deactivated {
  cursor: default;
  border-color: #E8E8E6;
}
.toggle-container.deactivated .on-half {
  border-right-color: #E8E8E6;
}
.toggle-container.deactivated .on-half span {
  color: #bebebe;
}
.toggle-container.deactivated .off-half.selected {
  background-color: #E8E8E6;
  border: none;
}
.toggle-container.deactivated .off-half.selected span {
  color: #bebebe;
}
.toggle-container.partial .on-half {
  background-color: white;
  color: #242424;
}
.toggle-container.partial .off-half {
  background-color: white;
}
.toggle-container.partial .partial-selected {
  border-right: 1px solid #02857D;
  background-color: #028570;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
}
.on-half {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #02857D;
}
.on-half span {
  margin: 0 0.25rem;
}
.on-half.selected {
  background-color: #02857D;
  color: white;
}
.off-half {
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #02857D;
}
.off-half span {
  margin: 0 0.25rem;
}
.off-half.selected {
  background-color: #EDEDED;
}
/*# sourceMappingURL=on-off-tri-toggle.component.css.map */
